import EventsTracking from '../../../shared/eventsTracking';

export function initTagging(taggingId) {
  return new EventsTracking(taggingId, {
    handlerOptions: {
      playback: { once: true },
    },
  });
}
